import React, { useState, useEffect } from 'react'
import load from "../../assets/Images/loader.gif";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import * as api from "../../api_function";


const CustomerLivePhotoFromOtherSource = () => {
    sessionStorage.setItem("userEmail", "crm.support@spectra.co")
    sessionStorage.setItem("userName", "crm.support")
    sessionStorage.setItem("password", "Spectra")

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const CafId = searchParams.get("CafId") && atob(searchParams.get("CafId"));
    const OppId = searchParams.get("OppId") && atob(searchParams.get("OppId"));
    // const role = searchParams.get("role"); 
    const role = "admin1";
    const userName = "crm.support";
    const password = "Spectra@8899@";
    // console.log(CafId, OppId);


    const [loading, setLoading] = useState(false);
    const [getCafDZationBusiness, setCafDZationBusiness] = useState();
    const [getOppDZationBusiness, setOppDZationBusiness] = useState();
    const [getContactPerson, setContactPerson] = useState();
    const [getCompanyName, setCompanyName] = useState();
    const [getEmailId, setEmailId] = useState();
    const [getInstallationAddress, setInstallationAddress] = useState();
    const [getFileName, setFileName] = useState();
    const [getCustomerImageStatus, setCustomerImageStatus] = useState(null);
    const [Caflatitude, setCaflatitude] = useState();
    const [Caflongitude, setCaflongitude] = useState();
    const [getEmpId, setEmpId] = useState();

    const [position, setPosition] = useState({ latitude: null, longitude: null });

    const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    // console.log(pos);
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

    useEffect(() => {
        getLocation();
    }, []);

    useEffect(() => {
        const getCafDZationB = async () => {
            try {
                if (!CafId) return;
                setLoading(true)
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    Action: "getCafDZationB",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    // Action: "getCafDigiHome",
                    // Authkey: "AdgT6SnjAkeLqlkE4",
                    cafNo: CafId,
                    oppid: "",
                    safNo: "",
                    password: password,
                    userName: userName
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                // console.log("result:", result?.Response?.Data);
                setCafDZationBusiness(result?.Response?.Data)

                if (Object.keys(result?.Response?.Data).length > 0) {
                    const data = result?.Response?.Data;
                    setCafDZationBusiness(result?.Response?.Data)

                    setCompanyName(data?.CompanyName)
                    setContactPerson(data?.CustomerName)
                    setEmailId(data?.installationAddresses?.Inst_EmailId)
                    setFileName(data?.customerImage?.FileNameWithExtension)
                    setEmpId(data?.EmployeeID)
                    const instObj = data?.installationAddresses;
                    const instAddress = instObj?.Inst_InstallationFloor + ", " + instObj?.Inst_BuildingNo + ", " + instObj?.Inst_BuildingAddress + ", " + instObj?.Inst_Country + " " + instObj?.Inst_PinCode;
                    // console.log(instAddress);
                    setInstallationAddress(instAddress)

                    const getLatLong = await api.getLatLong(instAddress)
                    // console.log("getLatLong: ", getLatLong);
                    setCaflatitude(getLatLong.Response.latitude);
                    setCaflongitude(getLatLong.Response.longitude);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        getCafDZationB();
    }, []);


    useEffect(() => {
        const getopportunity = async () => {
            try {
                if (CafId) return;
                setLoading(true);
                // console.log(searchParams.get("LeadId"));
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    userName: userName,
                    password: password

                    // userName: "manager1",
                    // password: "Spectr@man#23!"

                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                // console.log("result: ", result);

                if ((result?.Response?.Data).length > 0) {
                    const data = result?.Response?.Data[0];
                    setOppDZationBusiness(result?.Response?.Data[0])

                    setCompanyName(data?.Companyname)
                    setContactPerson(data?.ContactPerson)
                    setEmailId(data?.Emailaddress)
                    setFileName(data?.customerImage?.FileNameWithExtension)
                    setEmpId(data?.EmployeeID)
                    const instAddress = data?.Floor.trim() + ", " + data?.BuildingNo.trim() + ", " + data?.Buildingname.trim() + ", " + data?.Area.trim() + ", " + data?.Relationship.trim() + ", " + data?.State.trim() + ", " + data?.Country.trim() + " " + data?.PostalCode;
                    // console.log(instAddress);
                    setInstallationAddress(instAddress)

                    const getLatLong = await api.getLatLong(instAddress)
                    // console.log("getLatLong: ", getLatLong);
                    setCaflatitude(getLatLong.Response.latitude);
                    setCaflongitude(getLatLong.Response.longitude);
                    
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        getopportunity();
    }, []);


    const customerImageOnCAF = async (payload) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Action": "customerImageOnCAF",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "OppId": payload?.OppId || "",
                "CafID": payload?.CafID || "",
                "CustomerFileNameWithExtension": payload?.CustomerFileNameWithExtension || "",
                "CustomerFileContent": payload?.CustomerFileContent || "",
                "userName": userName,
                "password": password
            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            return data;
        } catch (err) {
            console.error("Error fetching data:", err);
            return err.message;
        }
    };


    const OpenCameraCustomer = (e) => {
          if (window.innerWidth >= 1024) {
            e.preventDefault();
            e.stopPropagation();
            Swal.fire({
                html: '<div style="font-size: 15px;">Customer live picture is not allowed on desktop.</div>',
            })
            return;
        }
        if (getFileName) { return }
        Swal.fire({
            html: '<div style="font-size: 20px;">Select Option</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
            cancelButtonText:
                '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // openCamera();
                document.getElementById("cameraFileInputCustomer").click();
            }
        });
    };

    const saveCustomerLivePicture = async (event) => {
        setLoading(true)
        const file = event.target.files[0];
        setFileName(file.name);
        // console.log("handleFileChangeCustomer: ", file.name);
        const extension = (file.name).substring((file.name).lastIndexOf("."));
        let fileName = 'customer_live_picture' + extension;


        if (!file) {
            toast.warning("Please Capture Live Picture", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        // Set compression options
        const options = {
            maxSizeMB: 1, // Maximum file size in MB
            maxWidthOrHeight: 1920, // Max width or height
            useWebWorker: true, // Use web worker for faster compression
        };
        try {
            // Compress the image file
            const compressedFile = await imageCompression(file, options);
            // Create a FileReader instance
            const reader = new FileReader();
            reader.onload = async (e) => {
                const base64StringBasic = e.target.result.split(";base64,")[1];
                let base64String = "";

                if (role?.toLowerCase() == "admin1") {
                    try {
                        setLoading(false)
                        const validateImageReq = {
                            "oppID": OppId || "",
                            "cafID": CafId || "",
                            "latitude": `${position?.latitude}` || Caflatitude || "",
                            "longitude": `${position?.longitude}` || Caflongitude || "",
                            "emp_code": getEmpId || sessionStorage.getItem("empId"),
                            "image_base64": base64StringBasic
                        }
                        const imagevalidateResult = await api.validateImage(validateImageReq)
                        const imagevalidate = imagevalidateResult?.data?.result;
                        // console.log("imagevalidate: ", imagevalidate);

                        if (imagevalidate?.code == 200 || imagevalidate?.code == 203) {
                            setCustomerImageStatus(imagevalidate)
                            if (imagevalidate?.code == 200) {
                                base64String = imagevalidate?.data?.watermarked_image
                            } else {
                                return
                            }
                        } else {
                            setCustomerImageStatus(null)
                        }

                    } catch (err) {
                        console.error(err);
                        // setCustomerImageStatus(null)
                    } finally { setLoading(false) }
                }

                // console.log("Compressed file content:", base64String); // Log base64 content
                const inputText = "Picture Captured";
                //   setCustomerPicture({ fileNameWithExtension: fileName, fileContent: base64String });
                //   setNewCafUpdateRequestBody((prevData) => ({
                //     ...prevData,
                //     customerImage: { fileNameWithExtension: fileName, fileContent: base64String }
                //   }));

                // console.log({ fileNameWithExtension: file.name, fileContent: base64String });
                if (CafId && base64String) {
                    let reqCaf = { CafID: CafId, CustomerFileNameWithExtension: file.name, CustomerFileContent: base64String };
                    let imageOnCafResult = await customerImageOnCAF(reqCaf);
                    // console.log(imageOnCafResult.StatusCode);
                    if (imageOnCafResult?.Status == "Success") {
                        toast.success("Customer image uploaded successfully!")
                    } else {
                        toast.error("Failed to upload, Please try again.")
                    }

                } else if (OppId && base64String) {
                    let reqOpp = { OppId: OppId, CustomerFileNameWithExtension: file.name, CustomerFileContent: base64String };
                    let imageOnCafResult = await customerImageOnCAF(reqOpp);
                    // console.log(imageOnCafResult);
                    if (imageOnCafResult?.Status == "Success") {
                        toast.success("Customer image uploaded successfully!")
                    } else {
                        toast.error("Failed to upload, Please try again.")
                    }
                }

            };
            reader.readAsDataURL(compressedFile);
        } catch (error) {
            console.error("Error:", error);
            toast.error("Please try again.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } finally {
            setLoading(false)
        }
    };

    return (
        <div>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                    // onClick={redirectBroadbandCafformPage}
                    >
                        {/* <i className="fa-solid fa-arrow-left-long"></i> */}
                    </span>
                    <span className="p-1 m-3">Customer Live Picture</span>
                </div>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            )}

            <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form1"
            >
                {/* *********Customer Details form******** */}
                <div className="container-fluid form-container">
                    <form className="contact-form p-2">
                        {OppId && (
                            <div
                                className="input-box form-floating "
                                style={{ position: "relative", paddingTop: "4px" }}
                            >
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="oppId"
                                    name="oppId"
                                    value={OppId}
                                    readOnly={true}
                                    style={{ background: "transparent" }}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>

                                <label htmlFor="floatingInput" className="lock mt-2">
                                    Opportunity ID
                                </label>
                            </div>
                        )}

                        {CafId && (
                            <div
                                className="input-box form-floating "
                                style={{ position: "relative", paddingTop: "4px" }}
                            >
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="CafId"
                                    name="CafId"
                                    value={CafId}
                                    readOnly={true}
                                    style={{ background: "transparent" }}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>

                                <label htmlFor="floatingInput" className="lock mt-2">
                                    CAF ID
                                </label>
                            </div>
                        )}

                        <div
                            className="input-box form-floating"
                            style={{ position: "relative", paddingTop: "4px" }}
                        >
                            <input
                                type="text"
                                placeholder=""
                                className="form-control input-text form-control-sm mt-1 "
                                id="Companyname"
                                name="Companyname"
                                value={getCompanyName}
                                readOnly
                                style={{ background: "transparent" }}
                            // onChange={formInputData}
                            />
                            <i
                                className="fa-solid fa-lock text-secondary"
                                style={{
                                    position: "absolute",
                                    right: "20px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                            <label htmlFor="floatingInput" className="lock mt-2">
                                Company Name
                            </label>
                        </div>

                        <div
                            className="input-box form-floating"
                            style={{ position: "relative", paddingTop: "4px" }}
                        >
                            <input
                                type="text"
                                placeholder=""
                                className="form-control input-text form-control-sm mt-1 "
                                id="ContactPerson"
                                name="ContactPerson"
                                value={getContactPerson}
                                readOnly
                                style={{ background: "transparent" }}
                            // onChange={formInputData}
                            />
                            <i
                                className="fa-solid fa-lock text-secondary"
                                style={{
                                    position: "absolute",
                                    right: "20px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                            <label htmlFor="floatingInput" className="lock mt-2">
                                Customer Name
                            </label>
                        </div>

                        <div
                            className="input-box form-floating "
                            style={{ position: "relative", paddingTop: "4px" }}
                        >
                            <input
                                type="text"
                                placeholder=""
                                className=" form-control input-text form-control-sm mt-1"
                                id="email"
                                name="email"
                                value={getEmailId}
                                readOnly
                                style={{ background: "transparent" }}
                            />
                            <i
                                className="fa-solid fa-lock text-secondary"
                                style={{
                                    position: "absolute",
                                    right: "20px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                            <label htmlFor="networkTechnology" className="lock mt-2">
                                Email ID
                            </label>
                        </div>

                        <div
                            className="form-floating "
                            style={{ position: "relative", paddingTop: "4px" }}
                        >
                            <input
                                type="text"
                                placeholder=""
                                className=" form-control input-text form-control-sm mt-1"
                                id="campaignName"
                                name="Product"
                                value={getInstallationAddress}
                                readOnly
                                style={{ background: "transparent" }}
                            />
                            <i
                                className="fa-solid fa-lock text-secondary"
                                style={{
                                    position: "absolute",
                                    right: "20px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                            <label htmlFor="floatingSelect" className="lock mt-2">
                                Installation Address
                            </label>
                        </div>

                        <div>
                            <div
                                className="input-box form-floating"
                                style={{ margin: "2.00rem 0 0 0", position: "relative" }}
                            >
                                <input
                                    id="cameraFileInputCustomer"
                                    type="file"
                                    accept="image/*"
                                    capture="camera"
                                    onChange={saveCustomerLivePicture}
                                    style={{ display: "none" }}
                                />
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="picture"
                                    name="livePicture"
                                    value={getFileName}
                                    accept="image/*"
                                    capture="camera"
                                    style={{ background: "transparent" }}
                                    onClick={OpenCameraCustomer}
                                    readOnly={true}
                                />
                                <i
                                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                    onClick={OpenCameraCustomer}
                                ></i>
                                <label htmlFor="floatingInput" className="paperclip mt-2">
                                    Customer Live Picture*
                                </label>
                            </div>



                            {/* ============ Validate Customer Live Picture ============= */}
                            {/* {console.log("getCustomerImageStatus: ", getCustomerImageStatus)} */}
                            {role?.toLowerCase() == "admin1" && getCustomerImageStatus != null && (
                                <div>
                                    {(getCustomerImageStatus?.status == "success") ? (
                                        <div className="d-flex align-items-center text-sm text-gray-500">
                                            <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                                                Image validated Successfully
                                            </div>
                                            <span className="text-success" >
                                                <i className="fas fa-check-circle"></i>
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="" style={{ opacity: ".70", fontSize: "14px", fontWeight: "300" }}>
                                            {/* Guidelines note */}
                                            <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                                                <div className="form-control-sm text-danger" style={{ fontSize: "12px", fontWeight: "400" }}>
                                                    Note: Please follow the guidelines and try again.
                                                </div>
                                            </div>
                                            {/* White Background Check */}
                                            <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                                                <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                                                    White Background Check
                                                </div>
                                                <span className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "text-success" : "text-danger"}>
                                                    <i className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                                                </span>
                                            </div>

                                            {/* Face Presence & Framing Check */}
                                            <div className="d-flex align-items-center text-sm text-gray-500">
                                                <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                                                    Face Presence & Framing Check
                                                </div>
                                                <span className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "text-success" : "text-danger"} >
                                                    <i className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ================= Guidelines for Capturing Your Photo ===================== */}

                        <div className="container mb-3 bg-body rounded mt-4 p-4 text-muted" id="form1" >
                            <h4 className="text-base font-semibold mb-3 text-gray-700 flex items-center">
                                📸 Guidelines for Capturing Your Photo
                            </h4>
                            <div className='text-muted'>
                                <p className="mb-4 text-sm text-gray-500">
                                    To ensure your photo meets verification standards, please follow these instructions carefully before capturing:
                                </p>

                                <div className="mb-4">
                                    <h5 className="font-semibold text-green-600 text-sm mb-2">✅ Do's</h5>
                                    <ul className="list-disc list-inside text-sm text-gray-500 space-y-1">
                                        <li><strong className="text-gray-700">Face the Camera Directly:</strong> Ensure your full face is visible and facing straight towards the camera.</li>
                                        <li><strong className="text-gray-700">Photo Background:</strong> Stand against a plain, white-colored background.</li>
                                        <li><strong className="text-gray-700">Clear Visibility:</strong> Make sure your face is well-lit and clearly visible.</li>
                                        <li><strong className="text-gray-700">Natural Expression:</strong> Maintain a neutral expression with your mouth closed and eyes open.</li>
                                    </ul>
                                </div>

                                <div>
                                    <h5 className="font-semibold text-red-600 text-sm mb-2">❌ Don'ts</h5>
                                    <ul className="list-disc list-inside text-sm text-gray-500 space-y-1">
                                        <li><strong className="text-gray-700">No Side Profiles or Tilts:</strong> Do not look away, tilt your head, or submit side profiles.</li>
                                        <li><strong className="text-gray-700">Avoid Shadows & Glare:</strong> Ensure there are no shadows on your face or background and avoid glares from glasses.</li>
                                        <li><strong className="text-gray-700">No Accessories Covering Face:</strong> Remove sunglasses, hats, or any items that obstruct the face.</li>
                                        <li><strong className="text-gray-700">Do Not Wear a Mask:</strong> Your full face must be clearly visible without any coverings.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    )
}

export default CustomerLivePhotoFromOtherSource